export { default as socialProofMapPNG } from '~/assets/images/anatomyV2/social-proof-map.png'
export { default as socialProofMapWEBP } from '~/assets/images/anatomyV2/social-proof-map.webp'
export { default as socialProofPressLogosPNG } from '~/assets/images/anatomyV2/social-proof-press-logos.png'
export { default as socialProofPressLogosWEBP } from '~/assets/images/anatomyV2/social-proof-press-logos.webp'

export const SOCIAL_PROOF_QUESTION = 'Social proof viewed'
export const SECTION_NUMBER = 6
